import React, { useState } from 'react';

const NAVY = '#1f4e79';
const ORANGE = '#f26522';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Inter:wght@400;500;600&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html { scroll-behavior: smooth; }
  body { font-family: 'Inter', sans-serif; -webkit-font-smoothing: antialiased; background: #f8fafc; }

  /* ── NAVBAR ── */
  .pp-nav {
    position: sticky; top: 0; z-index: 100;
    height: 68px; padding: 0 6%;
    background: rgba(255,255,255,0.97);
    backdrop-filter: blur(20px);
    border-bottom: 1px solid rgba(31,78,121,0.08);
    box-shadow: 0 4px 24px rgba(0,0,0,0.05);
    display: flex; align-items: center; justify-content: space-between;
  }
  .pp-brand { display: flex; align-items: center; gap: 10px; text-decoration: none; }
  .pp-brand img { height: 48px; width: auto; object-fit: contain; }
  .pp-brand-pill {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 10px; font-weight: 700; letter-spacing: 1.5px;
    text-transform: uppercase; color: ${ORANGE};
    background: rgba(242,101,34,0.10);
    border: 1px solid rgba(242,101,34,0.25);
    padding: 3px 10px; border-radius: 20px;
  }
  .pp-back {
    font-family: 'Inter', sans-serif; font-size: 14px; font-weight: 500;
    color: ${NAVY}; text-decoration: none;
    display: flex; align-items: center; gap: 6px;
    padding: 8px 16px; border-radius: 8px;
    border: 1.5px solid rgba(31,78,121,0.15);
    transition: all 0.2s;
  }
  .pp-back:hover { background: rgba(31,78,121,0.05); border-color: rgba(31,78,121,0.25); }

  /* ── HERO BANNER ── */
  .pp-hero {
    background: linear-gradient(160deg, ${NAVY} 0%, #0d2d52 60%, #07152a 100%);
    padding: 64px 6% 56px;
    position: relative; overflow: hidden;
  }
  .pp-hero::before {
    content: '';
    position: absolute; top: -100px; right: -100px;
    width: 500px; height: 500px; border-radius: 50%;
    background: radial-gradient(circle, rgba(242,101,34,0.12) 0%, transparent 65%);
    pointer-events: none;
  }
  .pp-hero-inner { max-width: 860px; margin: 0 auto; position: relative; z-index: 1; }
  .pp-eyebrow {
    display: inline-flex; align-items: center; gap: 8px;
    background: rgba(242,101,34,0.15); border: 1px solid rgba(242,101,34,0.25);
    padding: 6px 14px; border-radius: 20px; margin-bottom: 20px;
  }
  .pp-eyebrow span { font-size: 12px; font-weight: 600; color: ${ORANGE}; }
  .pp-hero h1 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: clamp(32px, 4vw, 48px); font-weight: 800;
    color: #fff; line-height: 1.15; letter-spacing: -1px; margin-bottom: 14px;
  }
  .pp-hero p { font-size: 15px; color: rgba(255,255,255,0.55); line-height: 1.7; }
  .pp-updated {
    display: inline-flex; align-items: center; gap: 8px;
    margin-top: 20px;
    background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.10);
    padding: 6px 14px; border-radius: 20px;
    font-size: 12px; color: rgba(255,255,255,0.50);
  }

  /* ── LAYOUT ── */
  .pp-layout {
    max-width: 860px; margin: 0 auto;
    padding: 56px 6% 100px;
    display: grid; grid-template-columns: 220px 1fr;
    gap: 48px; align-items: start;
  }

  /* ── SIDEBAR TOC ── */
  .pp-toc {
    position: sticky; top: 88px;
    background: #fff; border: 1px solid rgba(31,78,121,0.08);
    border-radius: 16px; padding: 20px;
    box-shadow: 0 4px 20px rgba(31,78,121,0.06);
  }
  .pp-toc-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 11px; font-weight: 700; color: #94a3b8;
    text-transform: uppercase; letter-spacing: 1.5px;
    margin-bottom: 14px; padding-bottom: 10px;
    border-bottom: 1px solid #f1f5f9;
  }
  .pp-toc-item {
    display: block; font-size: 13px; color: #64748b;
    text-decoration: none; padding: 7px 10px; border-radius: 8px;
    transition: all 0.2s; margin-bottom: 2px; cursor: pointer;
    background: none; border: none; width: 100%; text-align: left;
  }
  .pp-toc-item:hover { background: rgba(31,78,121,0.05); color: ${NAVY}; }
  .pp-toc-item.active { background: rgba(242,101,34,0.08); color: ${ORANGE}; font-weight: 600; }

  /* ── CONTENT ── */
  .pp-content { min-width: 0; }
  .pp-section {
    background: #fff; border: 1px solid rgba(31,78,121,0.08);
    border-radius: 20px; padding: 36px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px rgba(31,78,121,0.04);
    scroll-margin-top: 100px;
  }
  .pp-section-header {
    display: flex; align-items: center; gap: 14px; margin-bottom: 20px;
  }
  .pp-section-icon {
    width: 42px; height: 42px; border-radius: 12px; flex-shrink: 0;
    background: linear-gradient(135deg, rgba(31,78,121,0.08), rgba(242,101,34,0.08));
    display: flex; align-items: center; justify-content: center;
    font-size: 20px;
  }
  .pp-section-num {
    font-size: 11px; font-weight: 700; color: ${ORANGE};
    text-transform: uppercase; letter-spacing: 1.5px; margin-bottom: 2px;
  }
  .pp-section h2 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 18px; font-weight: 700; color: #0f172a;
  }
  .pp-text {
    font-size: 14.5px; color: #374151; line-height: 1.85;
    margin-bottom: 14px;
  }
  .pp-text:last-child { margin-bottom: 0; }
  .pp-text strong { color: #0f172a; font-weight: 600; }
  .pp-link { color: ${ORANGE}; text-decoration: none; font-weight: 500; }
  .pp-link:hover { text-decoration: underline; }

  /* List */
  .pp-list {
    list-style: none; margin: 12px 0;
  }
  .pp-list li {
    display: flex; gap: 10px; align-items: flex-start;
    font-size: 14.5px; color: #374151; line-height: 1.75;
    padding: 6px 0; border-bottom: 1px solid #f8fafc;
  }
  .pp-list li:last-child { border-bottom: none; }
  .pp-list-dot {
    width: 20px; height: 20px; border-radius: 50%; flex-shrink: 0; margin-top: 2px;
    background: rgba(242,101,34,0.10);
    display: flex; align-items: center; justify-content: center;
    color: ${ORANGE}; font-size: 11px; font-weight: 700;
  }

  /* Data table */
  .pp-table {
    border-radius: 12px; overflow: hidden;
    border: 1px solid rgba(31,78,121,0.08); margin: 16px 0;
  }
  .pp-table-head {
    display: grid; grid-template-columns: 140px 1fr;
    background: rgba(31,78,121,0.05); padding: 12px 20px;
    border-bottom: 1px solid rgba(31,78,121,0.08);
  }
  .pp-table-head span {
    font-size: 11px; font-weight: 700; color: #94a3b8;
    text-transform: uppercase; letter-spacing: 1px;
  }
  .pp-table-row {
    display: grid; grid-template-columns: 140px 1fr;
    padding: 13px 20px; border-bottom: 1px solid #f8fafc;
    align-items: center;
  }
  .pp-table-row:last-child { border-bottom: none; }
  .pp-table-row:nth-child(even) { background: #fafafa; }
  .pp-table-key { font-size: 13px; font-weight: 600; color: ${NAVY}; }
  .pp-table-val { font-size: 13px; color: #64748b; }

  /* Contact card */
  .pp-contact {
    background: linear-gradient(135deg, rgba(31,78,121,0.05), rgba(242,101,34,0.05));
    border: 1px solid rgba(31,78,121,0.10);
    border-radius: 14px; padding: 24px; margin-top: 16px;
  }
  .pp-contact-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 15px; font-weight: 700; color: #0f172a; margin-bottom: 14px;
  }
  .pp-contact-row {
    display: flex; align-items: center; gap: 10px;
    font-size: 14px; color: #374151; margin-bottom: 10px;
  }
  .pp-contact-row:last-child { margin-bottom: 0; }
  .pp-contact-icon { font-size: 16px; flex-shrink: 0; }

  /* Important notice */
  .pp-notice {
    background: rgba(242,101,34,0.05); border: 1px solid rgba(242,101,34,0.20);
    border-radius: 12px; padding: 16px 20px; margin: 16px 0;
    display: flex; gap: 12px; align-items: flex-start;
  }
  .pp-notice-icon { font-size: 18px; flex-shrink: 0; }
  .pp-notice-text { font-size: 14px; color: #92400e; line-height: 1.7; }

  /* Footer */
  .pp-footer {
    background: #060f1e; padding: 36px 6%;
    text-align: center;
  }
  .pp-footer p { font-size: 12px; color: rgba(255,255,255,0.30); line-height: 1.8; }

  /* Responsive */
  @media (max-width: 768px) {
    .pp-layout { grid-template-columns: 1fr; padding: 32px 5% 80px; }
    .pp-toc { display: none; }
    .pp-section { padding: 24px 20px; }
  }
  @media (max-width: 480px) {
    .pp-nav { height: auto; padding: 10px 4%; flex-wrap: nowrap; gap: 8px; }
    .pp-brand img { height: 44px; }
    .pp-brand-pill { font-size: 9px; padding: 2px 6px; }
    .pp-back {
      font-size: 12px; padding: 6px 10px;
      white-space: nowrap; flex-shrink: 0;
    }
    .pp-hero { padding: 40px 4% 36px; }
    .pp-hero h1 { font-size: 28px; }
    .pp-hero-inner { max-width: 100%; }
    .pp-layout { padding: 20px 4% 60px; }
    .pp-section { padding: 20px 16px; }
  }
`;

const SECTIONS = [
  { id: 'about', icon: '🏢', num: '01', title: 'About Hashvi Rental' },
  { id: 'collect', icon: '📋', num: '02', title: 'Information We Collect' },
  { id: 'use', icon: '⚙️', num: '03', title: 'How We Use Your Information' },
  { id: 'whatsapp', icon: '💬', num: '04', title: 'WhatsApp Messaging' },
  { id: 'retention', icon: '🗂️', num: '05', title: 'Data Retention' },
  { id: 'sharing', icon: '🔗', num: '06', title: 'Data Sharing' },
  { id: 'security', icon: '🔒', num: '07', title: 'Data Security' },
  { id: 'rights', icon: '⚖️', num: '08', title: 'Your Rights' },
  { id: 'changes', icon: '📝', num: '09', title: 'Changes to This Policy' },
  { id: 'contact', icon: '📬', num: '10', title: 'Contact Us' },
  { id: 'tos', icon: '📜', num: '11', title: 'Terms of Service' },
];

export default function PrivacyPolicy() {
  const [activeSection, setActiveSection] = useState('about');

  const scrollTo = (id) => {
    setActiveSection(id);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div>
      <style>{styles}</style>

      {/* NAVBAR */}
      <nav className="pp-nav">
        <a href="/" className="pp-brand">
          <img src="/Hashvi_logo_no_BG.svg" alt="Hashvi" />
          <span className="pp-brand-pill">Rental</span>
        </a>
        <a href="/" className="pp-back">← Back to Home</a>
      </nav>

      {/* HERO */}
      <div className="pp-hero">
        <div className="pp-hero-inner">
          <div className="pp-eyebrow">
            <span>🔒 Privacy Policy</span>
          </div>
          <h1>Your privacy matters to us.</h1>
          <p>
            Hashvi Rental is built on trust. This policy explains clearly what data we collect,
            why we collect it, and how we protect it. No jargon, no fine print.
          </p>
          <div className="pp-updated">
            📅 Last updated: April 24, 2026 · Hashvi Ventures Private Limited
          </div>
        </div>
      </div>

      {/* LAYOUT */}
      <div className="pp-layout">

        {/* SIDEBAR */}
        <aside className="pp-toc">
          <div className="pp-toc-title">Contents</div>
          {SECTIONS.map(s => (
            <button
              key={s.id}
              className={`pp-toc-item ${activeSection === s.id ? 'active' : ''}`}
              onClick={() => scrollTo(s.id)}
            >
              {s.num} · {s.title}
            </button>
          ))}
        </aside>

        {/* CONTENT */}
        <div className="pp-content">

          {/* 01 About */}
          <div className="pp-section" id="about">
            <div className="pp-section-header">
              <div className="pp-section-icon">🏢</div>
              <div>
                <div className="pp-section-num">Section 01</div>
                <h2>About Hashvi Rental</h2>
              </div>
            </div>
            <p className="pp-text">
              Hashvi Rental is a rental management platform operated by <strong>Hashvi Ventures Private Limited</strong>,
              a company registered in India (CIN: U62020KA2026PTC218075). Hashvi Rental helps landlords
              manage their rental properties and communicate with tenants via WhatsApp.
            </p>
            <p className="pp-text">
              This Privacy Policy explains how we collect, use, and protect your personal information
              in accordance with the Digital Personal Data Protection Act, 2023 (DPDP Act) and applicable
              Indian data protection regulations.
            </p>
            <p className="pp-text">
              For any privacy-related questions, contact us at:{' '}
              <a href="mailto:support@hashvi.in" className="pp-link">support@hashvi.in</a>
            </p>
          </div>

          {/* 02 Collect */}
          <div className="pp-section" id="collect">
            <div className="pp-section-header">
              <div className="pp-section-icon">📋</div>
              <div>
                <div className="pp-section-num">Section 02</div>
                <h2>Information We Collect</h2>
              </div>
            </div>
            <p className="pp-text">
              We collect only the information necessary to provide our rental management services:
            </p>
            <div className="pp-table">
              <div className="pp-table-head">
                <span>Category</span>
                <span>Data Collected</span>
              </div>
              {[
                { k: 'Landlords', v: 'Name, mobile number, email address' },
                { k: 'Tenants', v: 'Name, mobile number, move-in date, security deposit amount, last 4 digits of Aadhaar (text only)' },
                { k: 'Properties', v: 'Building name, address, unit numbers, rent amounts' },
                { k: 'Payments', v: 'Rent amount, payment date, payment mode, UPI transaction ID' },
                { k: 'Documents', v: 'Government-issued ID document (Voter ID, Passport or Driving License) and tenant face photo (optional KYC). Aadhaar cards are not accepted.' },
                { k: 'WhatsApp', v: 'Messages sent and received via WhatsApp Business API' },
              ].map((r, i) => (
                <div className="pp-table-row" key={i}>
                  <span className="pp-table-key">{r.k}</span>
                  <span className="pp-table-val">{r.v}</span>
                </div>
              ))}
            </div>
            <div className="pp-notice">
              <span className="pp-notice-icon">⚠️</span>
              <span className="pp-notice-text">
                We do not accept or store Aadhaar card images. Landlords are required to upload only government-issued ID documents such as Voter ID, Passport or Driving License. By uploading a document, the landlord confirms it is not an Aadhaar card. Only the last 4 digits of Aadhaar number may be stored as text for identification purposes, in compliance with UIDAI regulations.
              </span>
            </div>
          </div>

          {/* 03 Use */}
          <div className="pp-section" id="use">
            <div className="pp-section-header">
              <div className="pp-section-icon">⚙️</div>
              <div>
                <div className="pp-section-num">Section 03</div>
                <h2>How We Use Your Information</h2>
              </div>
            </div>
            <p className="pp-text">
              We use your information solely to provide the Hashvi Rental service:
            </p>
            <ul className="pp-list">
              {[
                'To authenticate landlords via WhatsApp OTP login',
                'To send rent payment reminders to tenants via WhatsApp',
                'To generate and deliver rent receipts to tenants via WhatsApp',
                'To notify landlords of incoming rent payments',
                'To maintain payment history and generate receipts for HRA purposes',
                'To send move-in welcome messages and move-out confirmations to tenants',
              ].map((item, i) => (
                <li key={i}><span className="pp-list-dot">✓</span>{item}</li>
              ))}
            </ul>
            <p className="pp-text" style={{ marginTop: 16 }}>
              We do <strong>not</strong> use your data for marketing, advertising, profiling,
              or any purpose other than providing the Hashvi Rental service.
            </p>
          </div>

          {/* 04 WhatsApp */}
          <div className="pp-section" id="whatsapp">
            <div className="pp-section-header">
              <div className="pp-section-icon">💬</div>
              <div>
                <div className="pp-section-num">Section 04</div>
                <h2>WhatsApp Messaging</h2>
              </div>
            </div>
            <p className="pp-text">
              Hashvi Rental uses the WhatsApp Business API (provided by Meta Platforms, Inc.) to send
              messages to landlords and tenants. By using Hashvi Rental, you consent to receiving
              WhatsApp messages from our business number for the purposes described above.
            </p>
            <p className="pp-text">
              Standard WhatsApp data processing terms apply as per{' '}
              <a href="https://www.whatsapp.com/legal/privacy-policy" target="_blank"
                rel="noreferrer" className="pp-link">
                WhatsApp's Privacy Policy
              </a>.
            </p>
          </div>

          {/* 05 Retention */}
          <div className="pp-section" id="retention">
            <div className="pp-section-header">
              <div className="pp-section-icon">🗂️</div>
              <div>
                <div className="pp-section-num">Section 05</div>
                <h2>Data Retention</h2>
              </div>
            </div>
            <ul className="pp-list">
              {[
                'Active tenant records are retained while the tenancy is active',
                'After a tenant moves out, their personal documents are deleted after 30 days automatically',
                'A pre-deletion WhatsApp notice is sent to the landlord 7 days before deletion',
                'Payment records and receipts are retained indefinitely for accounting purposes',
                'Landlord accounts are retained until the account is deleted upon request',
              ].map((item, i) => (
                <li key={i}><span className="pp-list-dot">✓</span>{item}</li>
              ))}
            </ul>
          </div>

          {/* 06 Sharing */}
          <div className="pp-section" id="sharing">
            <div className="pp-section-header">
              <div className="pp-section-icon">🔗</div>
              <div>
                <div className="pp-section-num">Section 06</div>
                <h2>Data Sharing</h2>
              </div>
            </div>
            <p className="pp-text">
              We do not sell, rent, or share your personal data with third parties except:
            </p>
            <ul className="pp-list">
              {[
                { t: 'Meta (WhatsApp)', d: 'To deliver WhatsApp messages to landlords and tenants' },
                { t: 'Railway', d: 'Our cloud hosting provider where data is stored securely' },
                { t: 'Cloudinary', d: 'Secure storage for tenant KYC documents with encrypted access' },
                { t: 'As required by law', d: 'If compelled by Indian law or court order' },
              ].map((item, i) => (
                <li key={i}>
                  <span className="pp-list-dot">✓</span>
                  <span><strong>{item.t}</strong> — {item.d}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* 07 Security */}
          <div className="pp-section" id="security">
            <div className="pp-section-header">
              <div className="pp-section-icon">🔒</div>
              <div>
                <div className="pp-section-num">Section 07</div>
                <h2>Data Security</h2>
              </div>
            </div>
            <p className="pp-text">
              We implement appropriate technical measures to protect your data:
            </p>
            <ul className="pp-list">
              {[
                'HTTPS encryption for all data in transit',
                'Secure PostgreSQL database with restricted access',
                'JWT-based authentication with WhatsApp OTP verification',
                'Tenant documents stored in private Cloudinary storage with signed expiring URLs',
                'No permanent public URLs for any personal documents',
              ].map((item, i) => (
                <li key={i}><span className="pp-list-dot">✓</span>{item}</li>
              ))}
            </ul>
            <p className="pp-text" style={{ marginTop: 12 }}>
              No method of transmission over the internet is 100% secure, but we take all
              reasonable precautions to protect your information.
            </p>
          </div>

          {/* 08 Rights */}
          <div className="pp-section" id="rights">
            <div className="pp-section-header">
              <div className="pp-section-icon">⚖️</div>
              <div>
                <div className="pp-section-num">Section 08</div>
                <h2>Your Rights</h2>
              </div>
            </div>
            <p className="pp-text">
              Under the Digital Personal Data Protection Act, 2023, you have the right to:
            </p>
            <ul className="pp-list">
              {[
                'Request access to your personal data held by Hashvi',
                'Request correction of inaccurate or incomplete data',
                'Request deletion of your account and associated personal data',
                'Withdraw consent for WhatsApp messaging at any time',
                'Nominate a person to exercise your rights in case of death or incapacity',
              ].map((item, i) => (
                <li key={i}><span className="pp-list-dot">✓</span>{item}</li>
              ))}
            </ul>
            <p className="pp-text" style={{ marginTop: 12 }}>
              To exercise any of these rights, contact us at{' '}
              <a href="mailto:support@hashvi.in" className="pp-link">support@hashvi.in</a>.
              We will respond within 30 days.
            </p>
          </div>

          {/* 09 Changes */}
          <div className="pp-section" id="changes">
            <div className="pp-section-header">
              <div className="pp-section-icon">📝</div>
              <div>
                <div className="pp-section-num">Section 09</div>
                <h2>Changes to This Policy</h2>
              </div>
            </div>
            <p className="pp-text">
              We may update this Privacy Policy from time to time to reflect changes in our
              practices or applicable law. We will notify landlords of significant changes via
              WhatsApp or email at least 7 days before changes take effect.
            </p>
            <p className="pp-text">
              Continued use of Hashvi Rental after changes constitutes acceptance of the
              updated policy. The date at the top of this page reflects the most recent update.
            </p>
          </div>

          {/* 10 Contact */}
          <div className="pp-section" id="contact">
            <div className="pp-section-header">
              <div className="pp-section-icon">📬</div>
              <div>
                <div className="pp-section-num">Section 10</div>
                <h2>Contact Us</h2>
              </div>
            </div>
            <p className="pp-text">
              For any privacy-related questions, data requests, or concerns — reach out to us:
            </p>
            <div className="pp-contact">
              <div className="pp-contact-title">Hashvi Ventures Private Limited</div>
              <div className="pp-contact-row">
                <span className="pp-contact-icon">📧</span>
                <a href="mailto:support@hashvi.in" className="pp-link">support@hashvi.in</a>
              </div>
              <div className="pp-contact-row">
                <span className="pp-contact-icon">💬</span>
                <span>WhatsApp: <a href="https://wa.me/919741400302" className="pp-link">+91 97414 00302</a></span>
              </div>
              <div className="pp-contact-row">
                <span className="pp-contact-icon">🌐</span>
                <a href="https://hashvi.in" className="pp-link">hashvi.in</a>
              </div>
              <div className="pp-contact-row">
                <span className="pp-contact-icon">🏢</span>
                <span>House No 12, 1st Cross, MCC Meenakshi Enclave, Prakash Layout, Vartur, Bangalore South, Karnataka 560087</span>
              </div>
              <div className="pp-contact-row">
                <span className="pp-contact-icon">📋</span>
                <span>CIN: U62020KA2026PTC218075</span>
              </div>
            </div>
          </div>

          {/* 11 Terms of Service */}
          <div className="pp-section" id="tos">
            <div className="pp-section-header">
              <div className="pp-section-icon">📜</div>
              <div>
                <div className="pp-section-num">Section 11</div>
                <h2>Terms of Service</h2>
              </div>
            </div>
            <p className="pp-text">
              By registering and using Hashvi Rental, you agree to the following terms:
            </p>
            <ul className="pp-list">
              {[
                { t: 'Permitted Use', d: 'Hashvi Rental is intended solely for landlords to manage their residential rental properties. Any misuse of the platform is strictly prohibited.' },
                { t: 'Document Upload Responsibility', d: 'You must not upload Aadhaar card images or full Aadhaar numbers. Only government-issued ID documents (Voter ID, Passport, Driving License) are permitted. By uploading any document, you confirm it is not an Aadhaar card. You are solely liable for any legal consequences arising from unauthorized uploads.' },
                { t: 'Tenant Data', d: 'You are responsible for obtaining consent from your tenants before adding their personal information to Hashvi Rental. You must inform tenants that their data is stored on Hashvi Rental.' },
                { t: 'WhatsApp Messaging', d: 'You authorize Hashvi Rental to send WhatsApp messages to your tenants on your behalf for rent reminders, receipts and notifications.' },
                { t: 'Account Security', d: 'You are responsible for maintaining the security of your account. Do not share your OTP or account access with anyone.' },
                { t: 'Account Termination', d: 'Hashvi Ventures reserves the right to terminate accounts that violate these terms, particularly those that upload prohibited documents or misuse the platform.' },
                { t: 'Data Accuracy', d: 'You are responsible for the accuracy of all data entered on the platform including tenant details, rent amounts and payment records.' },
                { t: 'Limitation of Liability', d: 'Hashvi Ventures is not liable for any financial disputes between landlords and tenants. The platform is a management tool and does not guarantee rent collection.' },
                { t: 'Changes to Terms', d: 'These terms may be updated from time to time. Continued use of the platform after changes constitutes acceptance of the updated terms.' },
              ].map((item, i) => (
                <li key={i}>
                  <span className="pp-list-dot">✓</span>
                  <span><strong>{item.t}</strong> — {item.d}</span>
                </li>
              ))}
            </ul>
            <div className="pp-notice" style={{ marginTop: 16 }}>
              <span className="pp-notice-icon">⚖️</span>
              <span className="pp-notice-text">
                By checking the Terms of Service checkbox during registration, you acknowledge that you have read, understood and agreed to all terms listed above. This constitutes a legally binding agreement between you and Hashvi Ventures Private Limited.
              </span>
            </div>
          </div>

        </div>
      </div>

      {/* FOOTER */}
      <footer className="pp-footer">
        <p>
          © 2026 Hashvi Ventures Private Limited · CIN U62020KA2026PTC218075 · Bangalore, Karnataka, India<br />
          Your Properties, Managed Smarter.
        </p>
      </footer>
    </div>
  );
}
